module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product form-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('group', {
    attrs: {
      "title": "管理人基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managerName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "管理人名称",
      "placeholder": "请输入管理人名称",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.data.managerName),
      callback: function($$v) {
        _vm.$set(_vm.data, "managerName", $$v)
      },
      expression: "data.managerName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构类型",
      "placeholder": "请输入机构类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgType", $$v)
      },
      expression: "data.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgCertificateType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgCertificateType),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgCertificateType", $$v)
      },
      expression: "data.orgCertificateType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgCertificateNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgCertificateNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgCertificateNo", $$v)
      },
      expression: "data.orgCertificateNo"
    }
  }), _vm._v(" "), _c('popup-radio', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "text-align": _vm.type === 0 ? 'right' : '',
      "title": "证件有效期",
      "options": ['永久有效', '存在有效期']
    },
    model: {
      value: (_vm.localValidity),
      callback: function($$v) {
        _vm.localValidity = $$v
      },
      expression: "localValidity"
    }
  }), _vm._v(" "), (_vm.localValidity === '存在有效期') ? _c('datetime', {
    ref: "orgValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "min-year": 2000,
      "max-year": 2099,
      "text-align": _vm.type === 0 ? 'right' : '',
      "readonly": _vm.type === 0
    },
    model: {
      value: (_vm.data.orgValidity),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgValidity", $$v)
      },
      expression: "data.orgValidity"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证明",
      "placeholder": "请输入机构资质证明名称,若无则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": "",
      "max": 20
    },
    model: {
      value: (_vm.data.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationProve", $$v)
      },
      expression: "data.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "placeholder": "请输入证书编号,若无则填\"无\"",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgQualificationNo", $$v)
      },
      expression: "data.orgQualificationNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgBusinessScope",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "经营范围",
      "placeholder": "请输入经营范围",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgBusinessScope", $$v)
      },
      expression: "data.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册地址",
      "placeholder": "请输入注册地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterAddress", $$v)
      },
      expression: "data.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgOfficeAddress",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公地址",
      "placeholder": "请输入办公地址",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgOfficeAddress),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgOfficeAddress", $$v)
      },
      expression: "data.orgOfficeAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisterCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgRegisterCapital),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgRegisterCapital", $$v)
      },
      expression: "data.orgRegisterCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.type === 0 ? 'right' : '',
      "disabled": _vm.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.data.orgController),
      callback: function($$v) {
        _vm.$set(_vm.data, "orgController", $$v)
      },
      expression: "data.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('submit-button', {
    on: {
      "click": _vm.$_product_auth
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab69db7"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Product/Three.vue
// module id = 1011
// module chunks = 1